import {
  Play, Flag, Keyboard, Variable, BrainCircuit, Building2, Target, BookOpen,
  GitBranch, Split, UserCheck, Clock, Server, FileDown,
} from "lucide-react";

// Fixed class strings (Tailwind can't build dynamic names).
export const NODE_META = {
  start:          { label: "Start",          icon: Play,        accent: "border-emerald-400/60 text-emerald-300", dot: "bg-emerald-400", group: "Flow" },
  end:            { label: "End",            icon: Flag,        accent: "border-red-400/60 text-red-300",         dot: "bg-red-400",     group: "Flow" },
  input:          { label: "Input",          icon: Keyboard,    accent: "border-sky-400/60 text-sky-300",         dot: "bg-sky-400",     group: "Data" },
  variable:       { label: "Variable",       icon: Variable,    accent: "border-violet-400/60 text-violet-300",   dot: "bg-violet-400",  group: "Data" },
  ai_strategist:  { label: "AI Strategist",  icon: BrainCircuit,accent: "border-gold/60 text-gold",               dot: "bg-gold",        group: "Intelligence" },
  department:     { label: "Department",     icon: Building2,   accent: "border-gold/60 text-gold",               dot: "bg-gold",        group: "Intelligence" },
  mission:        { label: "Mission",        icon: Target,      accent: "border-gold/60 text-gold",               dot: "bg-gold",        group: "Intelligence" },
  knowledge:      { label: "Knowledge",      icon: BookOpen,    accent: "border-teal-400/60 text-teal-300",       dot: "bg-teal-400",    group: "Intelligence" },
  condition:      { label: "Condition",      icon: Split,       accent: "border-amber-400/60 text-amber-300",     dot: "bg-amber-400",   group: "Logic" },
  decision:       { label: "Decision",       icon: GitBranch,   accent: "border-amber-400/60 text-amber-300",     dot: "bg-amber-400",   group: "Logic" },
  human_approval: { label: "Human Approval", icon: UserCheck,   accent: "border-orange-400/60 text-orange-300",   dot: "bg-orange-400",  group: "Control" },
  delay:          { label: "Delay / Wait",   icon: Clock,       accent: "border-slate-400/60 text-slate-300",     dot: "bg-slate-400",   group: "Control" },
  provider:       { label: "Provider",       icon: Server,      accent: "border-cyan-400/60 text-cyan-300",       dot: "bg-cyan-400",    group: "System" },
  export:         { label: "Export",         icon: FileDown,    accent: "border-green-400/60 text-green-300",      dot: "bg-green-400",  group: "System" },
};

export const NODE_ORDER = ["start", "input", "variable", "ai_strategist", "department", "mission",
  "knowledge", "condition", "decision", "human_approval", "delay", "provider", "export", "end"];

export const BRANCHING = new Set(["condition", "decision"]);
export const NO_TARGET = new Set(["start"]);
export const NO_SOURCE = new Set(["end"]);

export const REPLAY_RING = {
  active: "ring-2 ring-gold shadow-[0_0_20px_rgba(212,175,55,0.5)]",
  success: "ring-2 ring-emerald-400/70",
  error: "ring-2 ring-red-400/80",
  waiting: "ring-2 ring-amber-400/80",
  approved: "ring-2 ring-emerald-400/70",
  rejected: "ring-2 ring-red-400/80",
  changes_requested: "ring-2 ring-amber-400/80",
  skipped: "ring-2 ring-slate-500/60",
};
